import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AreaData } from 'src/app/model/area.model';
import { ApiService } from 'src/app/services/api.service';
import { Customer } from './../../model/customer.model';
import { Employee } from 'src/app/model/employee.model';
import _ from 'lodash';
@Component({
  selector: 'app-addcomplaint',
  templateUrl: './addcomplaint.component.html',
  styleUrls: ['./addcomplaint.component.scss']
})
export class AddcomplaintComponent implements OnInit {
    loggedUser: string ='';
    constructor(
      public dialogRef: MatDialogRef<AddcomplaintComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private apiService: ApiService,
      private _snackBar: MatSnackBar
    ) {}

    originalData :any;

    existingCustomer : boolean=true;
    isEditMode: boolean = false;
  
    onNoClick(): void {
      this.dialogRef.close();
    }
    areas: AreaData[];
    customers: Customer[];
    employees:Employee[];
    filteredEmployees: Employee[] = [];
    engineerSearchTerm: string = '';
    enableButton: boolean = false;

    ngOnInit() {

      // If complaintId exists, we are editing an existing complaint
      this.isEditMode = !!(this.data && this.data.complaintId);

      if (!this.isEditMode) {
        // New complaint: initialise default fields
        this.data ={
          ...this.data,
          "dateLogged": new Date().toISOString().split('T')[0], 
          "status":"New",
          "engineerRequired":"engineer",
          "description":"",
          "engineerId":-1,
          "engineerName":"",
          "engineerPhone":-1,
          "selectedArea":"",
          "selectedAreaId":-1,
          "resolvedStatus":"Pending",
          "loggedUser":this.loggedUser
        }
      }

      this.originalData = _.cloneDeep(this.data);
  
      console.log(this.originalData);

      this.apiService.getEmployees().subscribe((data) => {
        this.employees = data.employees;
        this.filteredEmployees = [...this.employees];

        // For new complaints, derive logged user name from employees
        if (!this.isEditMode) {
          const loggedInUser = Number(window.localStorage.getItem('loggedInUser'));
          const loggedInUserDetail = this.employees.find((emp) => emp.employeeId === loggedInUser);
          this.data.loggedUser = loggedInUserDetail?.employeeName || ""; 
        }

        this.originalData = _.cloneDeep(this.data);
      });
      
    this.apiService.getAreaDetails().subscribe((data) => {
      this.areas = data.areas;
    });
    this.apiService.getCustomers().subscribe((data) => {
      this.customers = data.customers;
    });

    }

    filterEngineers(): void {
      const term = (this.engineerSearchTerm || '').toLowerCase();
      if (!term) {
        this.filteredEmployees = [...this.employees];
        return;
      }

      this.filteredEmployees = this.employees.filter(emp =>
        emp.employeeName && emp.employeeName.toString().toLowerCase().includes(term)
      );
    }
    submitComplaint(complaintDetails: any): void {
      let selectedAreaName = this.areas.find((area)=>area.areaCode == this.data.selectedAreaId);
      let seletedEngineerName = this.employees.find((employee)=>employee.employeeId == this.data.engineerId);
      complaintDetails.selectedArea = selectedAreaName && selectedAreaName.areaName ? selectedAreaName.areaName:"";
      complaintDetails.engineerName = seletedEngineerName && seletedEngineerName.employeeName ?seletedEngineerName.employeeName:"";
      complaintDetails.engineerPhone = seletedEngineerName && seletedEngineerName.employeePhone ?seletedEngineerName.employeePhone:null;

      if (this.isEditMode) {
        // Editing an existing complaint: do NOT resolve it, just update details

        // Backend expects ISO-style dates with 'T' separator, like in resolveComplaint()
        if (complaintDetails.dateLogged && complaintDetails.dateLogged.indexOf(' ') !== -1) {
          complaintDetails.dateLogged = complaintDetails.dateLogged.replace(' ', 'T');
        }
        
        // Fix resolvedDate format to ensure ISO format with 'T'
        if (complaintDetails.resolvedDate && complaintDetails.resolvedDate.indexOf(' ') !== -1) {
          complaintDetails.resolvedDate = complaintDetails.resolvedDate.replace(' ', 'T');
        }

        // Keep it as not resolved
        if (!complaintDetails.resolvedStatus) {
          complaintDetails.resolvedStatus = 'Pending';
        }else if(complaintDetails.resolvedStatus === 'New'){
          complaintDetails.resolvedStatus = 'Pending';
        }

        this.apiService.resolveComplaint(complaintDetails).subscribe((data) => {
          if (data && data.isSuccess) {
            this.dialogRef.close();
            this._snackBar.open('Complaint updated successfully', 'Close', {
              duration: 3000,
            });
          } else {
            this._snackBar.open('Error occurred while updating complaint', 'Close', {
              duration: 3000,
            });
          }
        });
        return;
      }

      // New complaint creation
      complaintDetails.resolvedStatus="Pending";

      let dateUtc = new Date();

      // Convert to UTC+3 by adding 3 hours to the UTC time
      dateUtc.setUTCHours(dateUtc.getUTCHours() + 3);

      // Store the adjusted date in ISO format (without milliseconds)
      let dateLogged = dateUtc.toISOString().split('.')[0]; 
      let formattedDateTime = dateUtc.toISOString().split('T').join(' ').split('.')[0]; 
      complaintDetails.dateLogged = dateLogged; //"2024-11-14T20:56:10"
  
      this.apiService.addComplaint(complaintDetails).subscribe((data) => {
        if (data.complaintId && data.complaintId > 0) {
          this.dialogRef.close();
          this._snackBar.open('Complaint Created successfully with Complaint Id ' + data.complaintId, 'Close', {
            duration: 5000,
          });
        } else {
          this._snackBar.open('Error occured while Creating details', 'Close', {
            duration: 3000,
          });
        }
      });
    }


    
    resetData() {
      if (this.existingCustomer) {

        this.data = { ...this.originalData };
      

      } else {
        for (let key in this.data) {
       
            this.data[key] = "";
         
        }
        this.data.loggedUser=this.originalData.loggedUser;
        this.data.status ="New";
        this.data.dateLogged= new Date().toISOString().split('T')[0];
        this.data.engineerRequired="engineer";
      }
    }


    areFieldsFilled(): boolean {
      return this.data.description.trim() !== '' &&
             this.data.engineerId !== -1 &&
             this.data.selectedAreaId !== -1 &&
            this.data.customerId &&
            this.data.customerAddress &&
            this.data.customerName &&
            this.data.customerPhone
    }
  }
